import { Component } from "@/types/types"
import { cx } from "@/utils/cx"
import { SpinLoader } from "../SpinLoader"
import { Icon } from "../../media/Icon"

export const COMPONENT_NAME = "button"

export const presets = {
  variant: {
    primary: "text-text-onaccent bg-fill-accent [&:not(:disabled)]:hover:bg-fill-accent-hover",
    secondary:
      "text-text-primary bg-fill-secondary [&:not(:disabled)]:hover:bg-fill-secondary-hover",
    ghost: "text-text-primary bg-transparent [&:not(:disabled)]:hover:bg-fill-secondary-hover",
    danger: "text-text-inverse bg-fill-critical [&:not(:disabled)]:hover:bg-fill-critical-hover",
  },
  width: {
    contained: "w-full max-w-[144px]",
    adaptive: "",
    full: "w-full",
  },
  state: {
    ready: "",
    disabled: "",
    loading: "",
  },
}

export interface Props extends Component {
  label: string
  variant: keyof typeof presets.variant
  width?: keyof typeof presets.width
  type?: "button" | "submit"
  state?: keyof typeof presets.state
  onClick?: () => void
}

export function Button({
  label,
  variant,
  width = "contained",
  type = "button",
  state = "ready",
  onClick,
  className,
  testId = COMPONENT_NAME,
}: Props) {
  const disabled = ["loading", "disabled"].includes(state)

  return (
    <button
      className={cx(
        `h-12 font-semibold rounded px-4`,
        "transition",
        presets.variant[variant],
        presets.width[width],
        disabled && "pointer-events-none opacity-25",
        !disabled && "focus-ring",
        className,
      )}
      type={type}
      onClick={onClick}
      data-test={testId}
      disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
    >
      {state !== "loading" && <span className="select-none whitespace-nowrap">{label}</span>}
      {state === "loading" && (
        <Icon name="spinnerMd" className="h-6 w-6 animate-spin -my-1 mx-auto" />
      )}
    </button>
  )
}
